import { bl_mrp_job_template_to_process_option_hdr_RowClass, bl_mrp_job_template_to_process_option_line_RowClass } from '../../dbschema';
import { BaseContainerModel } from '../base-container.model';

export class MrpJobTemplateToProcessOptionContainerModel extends BaseContainerModel {
  bl_mrp_job_template_to_process_option_hdr: bl_mrp_job_template_to_process_option_hdr_RowClass = new bl_mrp_job_template_to_process_option_hdr_RowClass();
  bl_mrp_job_template_to_process_option_lines : bl_mrp_job_template_to_process_option_line_RowClass[] = [];
}
